"use client";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { io } from "socket.io-client";

interface ExchageData {
  name: string;
  symbol: string;
  abreviation: string;
  last_value: number;
}
interface Commision {
  id_commission: number;
  name: string;
  last_value: number;
}
const formatNumber = (value: number, currency: string, locale: string) => {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(value);
};
const formatPeso = (value: number) => {
  return new Intl.NumberFormat("es-ES", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

const TopBar: React.FC = () => {
  const [url, setUrl] = useState("");

  useEffect(() => {
    const path = window.location.pathname.split("/");
    const urlTemp = path[path.length - 1];
    setUrl(urlTemp);
  }, []);
  const [exchageData, setExchageData] = useState<ExchageData[]>([]);
  const [, /* commisionData */ setCommisionData] = useState<Commision[]>([]);

  const socketUrl = process.env.NEXT_PUBLIC_SOCKET_SERVER;

  const CommisionBancard = (commision: Commision, exchangeGs: ExchageData) => {
    const bancard =
      (commision?.last_value * exchangeGs?.last_value) / 100 +
      exchangeGs?.last_value;
    return formatNumber(bancard, "PYG", "es-PY");
  };

  useEffect(() => {
    const socket = io(socketUrl, {
      transports: ["websocket"],
    });
    // Conectar al socket

    socket.on("connect", () => {
      console.log("Conectado al socket");
    });

    socket.on("EXCHANGE_SUBSCRIPTION", (res) => {
      setExchageData(res);
    });
    socket.on("BANCARD_COMMISSION_SUBSCRIPTION", (res) => {
      setCommisionData(res);
    });
    // Limpiar la conexión al socket cuando el componente se desmonte
    return () => {
      socket.disconnect();
    };
  }, [socketUrl]);
  return (
    <div
      className={`top-header light ${
        url === "layout6" ? "top-header-inverse" : ""
      }`}
    >
      <div className="custom-container">
        <Row className="align-items-center">
          <Col xl="4" md="4" sm="12">
            <div className="top-header-left">
              <div className="shpping-order">
                <h6 style={{ color: "var(--bs-white)", fontWeight: "bold" }}>
                  ¡Tu mejor experiencia de compra online!
                </h6>
              </div>
            </div>
          </Col>
          <Col xl="4" md="4" sm="12">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: 20,
                color: "#ffffff",
              }}
            >
              <div className="d-flex align-items-center ">
                <p className="text-exchange">Cotización :</p>
              </div>
              <div className="d-flex align-items-center">
                <img
                  className="icon-exchange"
                  src="/images/exchange/py.png"
                  alt="Guarani"
                />
                <p>
                  {formatNumber(exchageData[1]?.last_value, "PYG", "es-PY")}
                </p>
              </div>
              <div className="d-flex align-items-center">
                <img
                  className="icon-exchange"
                  src="/images/exchange/br.png"
                  alt="Real"
                />
                <p>
                  {formatNumber(exchageData[2]?.last_value, "BRL", "pt-BR")}
                </p>
              </div>
              <div className="d-flex align-items-center">
                <img
                  className="icon-exchange"
                  src="/images/exchange/ar.png"
                  alt="Peso Ar"
                />
                <p>${formatPeso(exchageData[3]?.last_value)}</p>
              </div>
            </div>
          </Col>

          <Col xl="4" md="4" sm="12">
            <div className="top-header-right">
              <Link
                href="https://recruitment.newzone.com.py/"
                style={{
                  color: "var(--bs-white)",
                  fontWeight: "bold",
                  margin: "0 10px",
                }}
              >
                Trabaja con nosotros
              </Link>
              {/* <UserProfile /> */}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};
export default TopBar;
